export default "__VITE_ASSET__5jQwYEiW__"